module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_ohanabatake-83e03dba0e3e630c76749f08248a2d76.jpg";